import { CommodityName } from '@bechtel/sr-types';

export interface RenameTagsFormikState {
  commodityType: string;
  oldTag: string;
  newTag: string;
  isRevCardAuthorized: boolean;
  parentTag: string;
}

export const renameTagsInitialValues: RenameTagsFormikState = {
  commodityType: CommodityName.CABLE,
  oldTag: '',
  newTag: '',
  isRevCardAuthorized: true,
  parentTag: '',
};
